<template>
  <div>
    <h4>Dados da área</h4>
    <div class="border rounded-lg p-3 mb-3">
      <b-form-group label="Nome:">
        <b-form-input
          v-model="area.nome"
          placeholder="Nome"
          :state="validateState('nome')"
        />
        <b-form-text v-if="!!area.id">
          Para editar os dados de tradução do termo, clique em
          <b-button
            variant="link"
            size="sm"
            class="px-0"
            target="_blank"
            :to="{
              name: 'termos_filtros_edit',
              params: { id: area.id, tipo: 'area' },
            }"
          >
            editar tradução
            <font-awesome-icon icon="arrow-up-right-from-square" size="sm" />
          </b-button>
        </b-form-text>
        <b-form-invalid-feedback>
          Nome é um campo obrigatório.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Descrição:">
        <b-form-textarea
          v-model="area.descricao"
          placeholder="Descrição"
        ></b-form-textarea>
      </b-form-group>
    </div>

    <h4>Disponibilidade e organização</h4>
    <div class="border rounded-lg p-3 mb-3">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Status" v-slot="{ ariaDescribedby }">
            <div class="bg-status pl-3 py-3 rounded-lg">
              <b-form-checkbox
                v-model="area.status"
                name="status"
                switch
                :aria-describedby="ariaDescribedby"
              >
                <div class="d-inline-flex flex-column w-100 cursor-pointer">
                  <h5 class="mb-1">Ativar</h5>
                  <p class="mb-1">
                    Quando ativo, a área poderá ser exibida na plataforma e
                    vinculada a oportunidades.
                  </p>
                </div>
              </b-form-checkbox>
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Área pai:"
            description="Quando preenchido, indica que esta área pertence a outra área principal. Deixe vazio caso esta área não seja uma subárea."
          >
            <SelectArea
              v-model="area.area_id"
              :disable_node="area.id"
              :multiple="false"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import SelectArea from "../SelectArea.vue";

export default {
  mixins: [validationMixin],
  components: { SelectArea },
  data: () => ({}),
  validations: {
    area: {
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("areas", ["area"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.area[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.area.$touch();
      return !this.$v.area.$anyError;
    },
  },
  created() {},
};
</script>
<style scoped lang="scss">
::v-deep .custom-control-label {
  cursor: pointer;
  width: 100%;
}

::v-deep .vue-treeselect__control {
  height: 43px;

  .vue-treeselect__placeholder,
  .vue-treeselect__single-value {
    line-height: 43px;
  }
}

.rounded-group {
  border-radius: 6px;
}

.bg-status {
  --active-color: 34, 83, 115;
  border: 1px solid rgba(var(--active-color), 0.1);
  background-color: rgba(var(--active-color), 0.05);
  transition: 160ms;

  &:hover {
    background-color: rgba(var(--active-color), 0.091);
  }
}
</style>
